import R from "ramda";

export default error => (R.equals("null", error) ? null : error);
